import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Heading } from 'base-ui'

import { useMarketplacePartnerRegisterPageFormDictionary } from '../../../hooks/useMarketplacePartnerRegisterPageFormDictionary'
import { MarketplacePartnerRegisterPageFormSelectField } from '../MarketplacePartnerRegisterPageFormSelectField'

import { MarketplacePartnerRegisterPageFormTechnicalInformationsMiddlewarePartner } from './MarketplacePartnerRegisterPageFormTechnicalInformationsMiddlewarePartner'

export const MarketplacePartnerRegisterPageFormTechnicalInformations: FC =
  () => {
    const { shopSystemOptions } =
      useMarketplacePartnerRegisterPageFormDictionary()

    return (
      <div className="flex flex-col gap-10">
        <Heading level={2} size="l">
          <FormattedMessage id="marketplacePartnerRegisterPage.technicalInformations.title" />
        </Heading>
        <span className="flex flex-col gap-4">
          <span className="text-l">
            <FormattedMessage id="marketplacePartnerRegisterPage.technicalInformations.shopSystem.label" />
          </span>
          <MarketplacePartnerRegisterPageFormSelectField
            fieldName="shopSystem"
            label={
              <FormattedMessage id="marketplacePartnerRegisterPage.technicalInformations.shopSystem.placeholder" />
            }
            options={shopSystemOptions}
            required
          />
        </span>
        <MarketplacePartnerRegisterPageFormTechnicalInformationsMiddlewarePartner />
      </div>
    )
  }
